import { type FC } from 'react'

import { List } from '@dhl-ui/components'

import { ServicepointListItemDesktopSkeleton } from './ServicepointListItemDesktop.js'
import { ServicepointListItemMobileSkeleton } from './ServicepointListItemMobile.js'

type Props = {
  'data-testid'?: string
  isDesktop?: boolean
  numberOfItems?: number
}

export const ServicepointListSkeleton: FC<Props> = ({
  'data-testid': dataTestId,
  isDesktop = false,
  numberOfItems = 3,
}) => {
  const SkeletonItem = isDesktop ? ServicepointListItemDesktopSkeleton : ServicepointListItemMobileSkeleton

  return (
    <List data-testid={dataTestId}>
      {Array.from({ length: numberOfItems }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SkeletonItem key={index} />
      ))}
    </List>
  )
}
